import { needsReview, type BillingKind, type BillingRule } from '../../../utils/billingKind';
import type { FacilityFlowCoreModulesOffersDtosOfferPositionDto as PositionDto } from '../../../api/generated/models';

/** The edit form of an existing offer position. */
export interface EditForm {
  title: string;
  description: string;
  netAmount: string;
  instructions: string;
  interval: string;
  kind: BillingKind | null;
  rule: BillingRule;
  taskId: string;
}

export function toEditForm(position: PositionDto): EditForm {
  return {
    title: position.title ?? '',
    description: position.description ?? '',
    netAmount: position.netAmount != null ? String(position.netAmount) : '',
    instructions: position.instructions ?? '',
    interval: position.interval ?? '',
    // why: a legacy position without kind must be decided now, not saved as „zu prüfen" again.
    kind: needsReview(position.recurrenceKind) ? null : position.recurrenceKind ?? null,
    rule: position.billingRule ?? {},
    taskId: position.taskDefinitionId ?? '',
  };
}
